import React, { Component } from 'react';
import { connect } from 'react-redux';
import AccountUserDetailTagLogModal from '../../../../../views/account/user/detail/common/modal/AccountUserDetailTagLogModal';
import withModal from '../../../../../lib/hoc/withModal';
import { accountUserActions } from '../../../../../store/modules/account/user';

class AccountUserDetailTagLogModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { userToggleModal } = this.props;
    userToggleModal({
      name: 'accountUserTagLogModal',
      value: false,
    });
  };

  render() {
    return <AccountUserDetailTagLogModal {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.accountUser.accountUserTagLogModal.isOpen,
    data: state.accountUser.accountUserTagLogModal.data,
  };
};

const mapDispatchToProps = {
  userToggleModal: accountUserActions.userToggleModal,
  getAccountUserDetailTagLogList: accountUserActions.getAccountUserDetailTagLogList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(AccountUserDetailTagLogModalContainer));
